export const TARGET_COLLEGE_ADDED_TOAST_TITLE = 'College Successfully Added';

export const buildTargetCollegeAddedMessage = (collegeName) => {
    const name = collegeName || 'The college';
    return `${name} has been added to My Target Colleges.`;
};

export const COLLEGE_ALERTED_TOAST_TITLE = 'College Alerted';

export const buildCollegeAlertedMessage = (collegeName) => {
    const name = collegeName || 'The college';
    return `${name} has been alerted that you are interested in their program.`;
};

export const COLLEGE_ALERT_REMOVED_TOAST_TITLE = 'Alert Removed';

export const buildCollegeAlertRemovedMessage = (collegeName) => {
    const name = collegeName || 'the college';
    return `You will no longer be visible as an interested prospect on the ${name} page.`;
};
